import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../components/providers/FiltersProvider";
import PageHeader from "../../layout/shared/page-header";
import { menuRoutes } from "../../router/menu";
import cn from "../../utils/classNames";
import InspectorCredentialsList from "./list/InspectorCredentialsList";

const InspectorCredentialsListWrapper = () => {

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Productos', href: menuRoutes.products.path },
        { name: 'Credenciales inspector AF', href: menuRoutes.products.path + menuRoutes.products.inspectorCredentials },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Credenciales inspector" breadcrumb={breadCrumb}>
                    {
                        userCan('create_inspector_credentials', 'inspector_credentials') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { navigate(menuRoutes.products.path + menuRoutes.products.inspectorCredentials + '/create') }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Nueva credencial
                            </Button>
                        )
                    }

                </PageHeader>
                <InspectorCredentialsList />
            </FiltersProvider>
        </Fragment>
    );
}

export default InspectorCredentialsListWrapper;
